<template>
  <div class="cx-focus-kpi-grid">
    <CxFocusKpiItem class="cx-card cx-card-sm"
                    :dashboardData="dashboardData"
                    @focuskpigrid-close-help-popups="closeHelpPopups"
                    v-for="(item, index) in getItems"
                    :ref="getRefName(item.SortOrder)"
                    :reference="getRefName(item.SortOrder)"
                    :key="index" 
                    :kpi="item"
                    :theme="theme"
                    :threshold="threshold" />
  </div>
</template>

<script>
import CxFocusKpiItem from './CxFocusKpiItem.vue';

export default {
  components: {
    CxFocusKpiItem
  },

  props: {
    dashboardData:    { type: Object, default: () => undefined },
    focusKpis:        { type: Object, default: () => undefined },
    fixFocusKpis:     { type: Boolean, default: () => false },
    ownerIsRetailers: { type: Boolean, default: () => false },
    theme:            { type: String, default: () => 'light' },
    threshold:        { type: Array, required: true }
  },

  methods: {
    closeHelpPopups(event) {
      for (const item of this.getItems) {
        let reference = this.getRefName(item.SortOrder);
        if (reference === event) 
          continue;
        
        let popupReference = this.$refs[reference];
        if (popupReference) {
          popupReference[0].toggleHelpPopup(true);
        }
      }
    },

    getRefName(index) {
      return `kpi${index}`;
    }
  },

  computed: {
    getItems() {
      if (!this.focusKpis)
        return [];
      let items = this.focusKpis.kpis ? this.focusKpis.kpis : this.focusKpis;
      let array = Object.values(items);
      if (this.fixFocusKpis) {
        array = array.filter(item => item.name !== 'average_responsetime');
      }

      // Show Actions Button only on Dashboard
      let item = array.find(item => item.name === 'firstaidkits');
      if (item) {
        item.disableActions = this.ownerIsRetailers;
      }

      // if any in array does not have SortOrder, add SortOrder starting with 1
      if (array.some(item => item.SortOrder === undefined)) {
        let sortOrder = 1;
        for (const item of array) {
          if (item.SortOrder === undefined) {
            item.SortOrder = sortOrder;
            sortOrder++;
          }
        }
      }

      array.sort((a, b) => a.SortOrder - b.SortOrder);
      return array;
    }
  }
}
</script>

<style scoped>
.cx-focus-kpi-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 1rem;
  min-width: 50%;
}

.target {
  grid-column: 3;
  grid-row: 1 / 3;
}
</style>